import * as React from 'react';

import {
  AssistantMessage,
  AssistantMessageWithCode,
  AssistantMessageWithError,
} from 'src/containers/Voicebox/Message/AssistantMessage';
import { useMessageLineInfo } from 'src/containers/Voicebox/Message/hooks/useMessageLineInfo';
import {
  UserMessage,
  UserMessageWithError,
} from 'src/containers/Voicebox/Message/UserMessage';
import { voiceboxConversationSelector } from 'src/selectors/voicebox';
import { useReduxSelector } from 'src/utils/hooks/useReduxSelector';
import {
  VoiceboxMessage,
  isDescribeResponseMessage,
  isExistingModelMessage,
  isProgressMessage,
  isTurtleRequestMessage,
  isTurtleResponseMessage,
} from 'src/utils/voicebox/types';

export const VoiceboxMessageLine: React.VFC<{
  message: VoiceboxMessage;
  isLastMessage: boolean;
}> = ({ message, isLastMessage }) => {
  const messages = useReduxSelector(voiceboxConversationSelector);
  const { pending } = useMessageLineInfo();
  const messagePending = pending && isLastMessage;

  if (isTurtleRequestMessage(message)) {
    const { errored, userPrompt } = message;

    if (errored) {
      return (
        <UserMessageWithError
          pending={messagePending}
          userPrompt={userPrompt}
        />
      );
    }

    return <UserMessage pending={messagePending} userPrompt={userPrompt} />;
  }

  if (isExistingModelMessage(message)) {
    const { humanText } = message;
    return <UserMessage pending={messagePending} userPrompt={humanText} />;
  }

  if (isProgressMessage(message)) {
    const { content } = message;
    return <AssistantMessage before={content} pending={messagePending} />;
  }

  if (isTurtleResponseMessage(message)) {
    const { after, before, code, content, describeResponseMessageId, errored } =
      message;

    if (errored) {
      return (
        <AssistantMessageWithError before={content} pending={messagePending} />
      );
    }
    const temp = describeResponseMessageId
      ? messages.find((message) => message.id === describeResponseMessageId)
      : undefined;

    let describeResponseMessage;
    if (isDescribeResponseMessage(temp)) {
      describeResponseMessage = temp;
    }

    return (
      <AssistantMessageWithCode
        after={after}
        before={before}
        code={code}
        describeResponseMessage={describeResponseMessage}
        pending={messagePending}
      />
    );
  }

  return null;
};
